import { LineChart, Coins, Building2, DollarSign, ArrowDownLeft, ArrowUpRight, Wallet, Receipt } from "lucide-react";

export const KIND_LABEL = { stock: "Stock", crypto: "Crypto", cash: "Cash", money_market: "Money Market Fund", other: "Other" };
export const KIND_ICON = { stock: Building2, crypto: Coins, cash: DollarSign, money_market: Wallet, other: LineChart };

export const ACTIVITY_KIND_META = {
  dividend: { label: "Dividend received", icon: ArrowDownLeft, income: true,  tone: "text-[#2F6B4A] bg-[#E8F5EC]" },
  interest: { label: "Interest received", icon: ArrowDownLeft, income: true,  tone: "text-[#2F6B4A] bg-[#E8F5EC]" },
  buy:      { label: "Buy shares",        icon: ArrowUpRight,  income: false, tone: "text-[#0369a1] bg-[#E5F0F7]" },
  sell:     { label: "Sell shares",       icon: ArrowDownLeft, income: true,  tone: "text-[#2F6B4A] bg-[#E8F5EC]" },
  fee:      { label: "Broker fee",        icon: Receipt,       income: false, tone: "text-[#B4283A] bg-[#FCE8EB]" },
};

